import * as React from 'react';
import { SVGProps } from 'react';

const IconMeatballSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM1 6a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" />
  </svg>
);
export default IconMeatballSizeXs;
